import React, { useEffect, useState } from "react";
import {
  MdHealthAndSafety,
  MdOutlineMedicalServices,
  MdOutlineLocalHospital,
  MdSupportAgent,
  MdEmergency,
  MdNetworkCheck,
  MdSupervisorAccount,
  MdOutlineAddHome,
} from "react-icons/md";

// 🧭 Icon mapping
const iconMap = {
  MdHealthAndSafety,
  MdOutlineAddHome,
  MdOutlineMedicalServices,
  MdOutlineLocalHospital,
  MdSupportAgent,
  MdEmergency,
  MdNetworkCheck,
  MdSupervisorAccount,
};

const KeyStrengths = React.memo(() => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("/AllJson/keyhighlight.json", {
          cache: "force-cache",
        });
        const json = await res.json();
        console.log(json.keyhigh);
        setData(json.keyhigh || []);
      } catch (err) {
        console.error("Error loading key strengths:", err);
      }
    };
    fetchData();
  }, []);
  // console.log(data);

  return (
    <section
      id="key-strengths"
      aria-labelledby="key-strengths-heading"
      className="bg-cream text-maroon-dark py-16 px-4 sm:px-8 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <header className="text-center mb-12">
          <h2
            id="key-strengths-heading"
            className="text-3xl sm:text-4xl font-extrabold text-maroon mb-4"
          >
            Our Key Highlights
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Delivering care, compassion, and trust — all under one roof.
          </p>
        </header>

        {/* Grid */}
        <ul
  role="list"
  className="flex flex-wrap justify-center gap-8"
>
  {data.map((item, index) => {
    const Icon = iconMap[item.icon];
    return (
      <li
        key={index}
        className="relative group overflow-hidden rounded-2xl shadow-lg border border-gold cursor-pointer
                   basis-[100%] sm:basis-[45%] lg:basis-[30%]"
      >
        <div className="relative w-full h-64 overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 blur-sm"
            onLoad={(e) => e.target.classList.remove("blur-sm")}
          />
        </div>

        <div className="absolute inset-0 bg-black/50 transition-all duration-700 group-hover:bg-black/70"></div>

        <div className="absolute inset-0 flex flex-col justify-end items-center text-white text-center px-6 pb-6">
          {Icon && (
            <Icon className="text-4xl text-gold mx-auto mb-3 font-semibold transition-all duration-700 group-hover:translate-y-[-100%]" />
          )}

          <div className="opacity-0 translate-y-10 group-hover:opacity-100 group-hover:translate-y-[-10px] transition-all duration-700 ease-out">
            <h3 className="text-xl font-semibold mb-2 transition-all duration-700">
              {item.title}
            </h3>

            <p className="text-sm text-gray-200">{item.desc}</p>
          </div>
        </div>
      </li>
    );
  })}
</ul>

      </div>
    </section>
  );
});

export default KeyStrengths;
